import { render, staticRenderFns } from "./ScreeningsOnholdTable.vue?vue&type=template&id=299be99d&scoped=true&"
import script from "./ScreeningsOnholdTable.vue?vue&type=script&lang=js&"
export * from "./ScreeningsOnholdTable.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsOnholdTable.vue?vue&type=style&index=0&id=299be99d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299be99d",
  null
  
)

export default component.exports